<template>
    <div class="modal-card">
        <header class="modal-card-head has-background-white bb-none headerRestoreAccrual px-5 pt-5 pb-0">
            <div class="startRestoreAccrual">
                <div class="flipBackHeader" :style="headerIconBgClass ? '' : 'background: #FEE4E2;'" :class="headerIconBgClass">
                    <component v-if="iconComponent" :is="iconComponent" class="svgIcon"></component>
                    <FlipBackward v-else class="svgIcon" />
                </div>
                <span class="titleRestoreAccrual ml-2">
                </span>
            </div>

            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body p-0 px-5 pb-2 pt-4">
            <p class="tittleBodyModal mb-1"> {{ tittleRestore }}</p>
            <p class="descBodyModal">
                {{ subTittleRestore }}
                <strong class="is-capitalized"> {{ endSubTittleBold }} </strong>
            </p>
        </section>
        <footer class="modal-card-foot bt-none has-background-white">
            <button class="button is-flex-grow-3" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                {{ cancelText }}
            </button>
            <button class="button is-flex-grow-1" :class="btnClass" :aria-label="msgOkAction" role="button"
                @click="restoreAccrual()">
                {{ msgOkAction }}
            </button>
        </footer>
    </div>
</template>
<script>
import FlipBackward from "@/components/svg/FlipBackward.vue";
export default {
    name: "ConfirmRestore",
    data() {
        return {
        };
    },
    components: {
        FlipBackward
    },
    methods: {
        restoreAccrual() {
            this.$emit(this.eventNameConfirmRestore);
            this.$emit("close");
        },
    },
    props: {
        eventNameConfirmRestore: { type: String, required: true },
        tittleRestore: { type: String, required: true },
        subTittleRestore: { type: String, required: true },
        endSubTittleBold: { type: String, required: false },
        msgOkAction: { type: String, required: true },
        cancelText: { type: String, default: 'Cancelar' },
        btnClass: { type: String, default: 'is-danger' },
        headerIconBgClass: { type: String, default: '' },
        iconComponent: { default: null }
    }
};
</script>
<style lang="scss" scoped>
.modal-card {
    margin: auto !important;
    justify-content: center;
}

.tittleBodyModal {
    color: #101828;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
}

.descBodyModal {
    color: #475467;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
}

.bb-none {
    border-bottom: none;
}

.headerRestoreAccrual {
    display: flex;
    border-bottom: none;

    .startRestoreAccrual {
        display: flex;

        .flipBackHeader {
            width: 48px;
            height: 48px;
            padding: 10px;
            justify-content: center;
            align-items: center;
            border-radius: 24px;
            background: #FEE4E2;

            .svgIcon {
                width: 30px;
                height: 30px;
                filter: invert(18%) sepia(48%) saturate(5812%) hue-rotate(354deg) brightness(102%) contrast(86%);
            }
        }

        .titleRestoreAccrual {
            flex: 1;
            color: #101828;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            text-transform: uppercase;
        }
    }

    .delete {
        margin-left: auto;
    }

}
</style>